import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["views", "selectedView"];
import { fetchOnboardingSettings, patchOnboardingSettings } from './api/onboardingSettingsApi';
import { setGroupKey } from './api/userContextApi';
/**
 * To be kept in sync with the types in onboarding-settings-client:
 * {@link https://git.hubteam.com/HubSpot/onboarding-settings-client/blob/568692dbaf325e806a0c2d95957d6018bb766df4/onboarding-settings-client/static/js/constants/onboardingViews.ts#L6 onboarding-settings-client/static/js/constants/onboardingViews.ts}
 */
export const ONBOARDING_VIEWS = {
  SALES: 'sales',
  MARKETING: 'marketing',
  SERVICE: 'service',
  CMS: 'cms',
  COMMERCE: 'commerce',
  OPS: 'ops',
  SUITE: 'suite',
  BUSINESS_BOX: 'businessBox',
  USE_CASE: 'useCase'
};

/**
 * To be kept in sync with the types in onboarding-settings-client:
 * {@link https://git.hubteam.com/HubSpot/onboarding-settings-client/blob/568692dbaf325e806a0c2d95957d6018bb766df4/onboarding-settings-client/static/js/constants/onboardingViews.ts#L23 onboarding-settings-client/static/js/constants/onboardingViews.ts}
 */

export const getOnboardingSettings = () => {
  return fetchOnboardingSettings();
};
export const setOnboardingSettings = (onboardingSettings, _userId, _portalId, _options) => {
  const {
      views,
      selectedView
    } = onboardingSettings,
    rest = _objectWithoutPropertiesLoose(onboardingSettings, _excluded);
  const decoratedViews = views ? Object.fromEntries(Object.entries(views).map(([k, v]) => [k.toUpperCase(), v])) : undefined;
  return patchOnboardingSettings(Object.assign({}, rest, {
    views: decoratedViews,
    selectedView: selectedView === null || selectedView === void 0 ? void 0 : selectedView.toUpperCase()
  }));
};
export const setHubOnboardingSettings = (view, settings, _userId, _portalId) => {
  const onboardingSettings = {
    views: {
      [view]: settings
    },
    selectedView: view
  };
  const settingsRequests = [setOnboardingSettings(onboardingSettings)];
  if (settings.groupKey) {
    settingsRequests.push(setGroupKey(settings.groupKey));
  }
  return Promise.all(settingsRequests);
};